import { booleanAttribute, Component, Input } from '@angular/core';
import { Filter } from '../../../models/export/filter.model';
import { ExportService } from '../../services/export.service';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-export-download-button',
  templateUrl: './download-button.component.html',
  styleUrl: './download-button.component.scss',
  imports: [MatTooltip, MatIcon, TranslocoPipe],
})
export class DownloadButtonComponent {
  @Input({ transform: booleanAttribute }) buttonDisable: boolean = false;
  @Input() itemId?: number;
  @Input() endpointExcel?: string;
  @Input() filters?: Filter[];

  constructor(private readonly exportService: ExportService) {}

  downloadItemsSummary(): void {
    this.itemId !== undefined &&
      this.endpointExcel !== undefined &&
      this.exportService.downloadAndSaveFile(
        this.endpointExcel.replace('{idCompensation}', String(this.itemId)),
        undefined,
        this.filters,
      );
  }
}
